import type {CellType} from '../constants';
import type {ValueAcc} from '../typedef';

export const countErrors = (data: ValueAcc): number => {
    let errorCount = 0;
    const types = Object.keys(data);
    for (const type of types) {
        errorCount += data[type as CellType].isValid ? 0 : 1;
    }
    return errorCount;
};
